export const labels = {
  legality: {
    label: "Legality",
  },
  humanRights: {
    label: "Human Rights",
  },
  conflictSecurity: {
    label: "Conflict & Security",
  },
  environment: {
    label: "Environment & Natural Resources",
  },
  healthSafety: {
    label: "Health & Safety",
  },
  communitySociety: {
    label: "Community & Society",
  },
};

export const mapData = (baseline, comparison, t = (s) => s) => {
  return Object.entries(labels).map(([k, value], i) => {
    const label = t(value.label);
    const Baseline = baseline ? baseline[k] || 0 : 0;
    const Comparison = comparison ? comparison[k] || 0 : 0;
    return { label, item: i.toString(), Comparison, Baseline };
  });
};
